import React, { useState } from 'react';
import { Eye, EyeOff, Check, X, RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';
import AudioButton from './AudioButton';
import { cn } from '../../lib/utils';

const ReviewCard = ({ phrase, onResult, className }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const { en, pt, strength } = phrase;

  const strengthColor = strength < 0.3 ? 'bg-destructive' : strength < 0.6 ? 'bg-warning' : 'bg-success';
  const strengthLabel = strength < 0.3 ? 'Fraco' : strength < 0.6 ? 'Médio' : 'Forte';

  return (
    <div className={cn('card-elevated p-6', className)}>
      {/* Strength indicator */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className={cn('w-2 h-2 rounded-full', strengthColor)} />
          <span className="text-xs text-muted-foreground">{strengthLabel}</span>
        </div>
        <AudioButton text={en} size="sm" />
      </div>

      {/* Question */}
      <div className="text-center py-6">
        <p className="text-lg font-medium text-muted-foreground mb-2">Traduza para português:</p>
        <p className="text-2xl font-display font-semibold">{en}</p>
      </div>

      {/* Answer */}
      {showAnswer ? (
        <div className="space-y-4 animate-fade-in">
          <div className="p-4 rounded-xl bg-muted text-center">
            <p className="text-lg font-medium">{pt}</p>
          </div>

          <p className="text-sm text-center text-muted-foreground">
            Como foi sua resposta?
          </p>

          <div className="flex gap-2">
            <Button
              variant="outline"
              className="flex-1 border-destructive/50 hover:bg-destructive/10 hover:text-destructive"
              onClick={() => onResult && onResult('wrong')}
            >
              <X className="w-4 h-4 mr-2" />
              Errei
            </Button>
            <Button
              variant="outline"
              className="flex-1 border-warning/50 hover:bg-warning/10 hover:text-warning"
              onClick={() => onResult && onResult('hard')}
            >
              <RotateCcw className="w-4 h-4 mr-2" />
              Difícil
            </Button>
            <Button
              variant="outline"
              className="flex-1 border-success/50 hover:bg-success/10 hover:text-success"
              onClick={() => onResult && onResult('correct')}
            >
              <Check className="w-4 h-4 mr-2" />
              Acertei
            </Button>
          </div>
        </div>
      ) : (
        <Button
          onClick={() => setShowAnswer(true)}
          className="w-full btn-primary-gradient"
        >
          <Eye className="w-4 h-4 mr-2" />
          Ver Resposta
        </Button>
      )}
    </div>
  );
};

export default ReviewCard;
